import React, { FC } from "react";

import { PaymentFiltersBase } from "./PaymentFiltersBase";
import { usePaymentFiltersController } from "../../../hooks/usePaymentFiltersController";

type Props = {
  controller: ReturnType<typeof usePaymentFiltersController>;
};

export const PaymentsListFilters: FC<Props> = ({ controller }) => {
  return (
    <PaymentFiltersBase
      showFilters={["client", "payment-date", "label"]}
      filter={controller.filter}
      setFilter={controller.setFilter}
      filterByContact={controller.filterByContact}
      setFilterByContact={controller.setFilterByContact}
      filterByLabel={controller.filterByLabel}
      setFilterByLabel={controller.setFilterByLabel}
      clientOptions={controller.clientOptions}
      labelOptions={controller.labelOptions}
      isLoadingContacts={controller.isLoadingContacts}
      searchClients={controller.searchClients}
      setSearchClients={controller.setSearchClients}
      billing
    />
  );
};
